import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";

import {authenticationService} from "../../../../services/AuthenticationService";
import TreatmentPlanBlock from "../../../../components/PatientOnboard/TreatmentPlanBlock";
import TreatmentPlanNotExpanded from "../../../../components/PatientOnboard/TreatmentPlanNotExpanded";
import SvGraphics from "../../../../assets/SvGraphics";


class RequestTreatmentTargetsTabComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 1,
            entry: this.props.entry,
            showTreatment: 0,
            patientTreatments: this.props.patientTreatments,
            currentTreatment: this.props.currentTreatment,
            titrationPlan: this.props.titrationPlan,
            isTitrationSchedule: false,
            choosenTargetsSymptoms: this.props.choosenTargetsSymptoms,
        };
    }

    onValueChange = (name, value) => {
        this.props.onValueChange(name, value)
    }

    componentDidMount() {
    }

    setTitrationSchedule = (val, index) => {
        if (val === "Titration") {
            this.setState({isTitrationSchedule: true})

        } else {
            this.props.getTitrationPlan("New", index)
            this.setState({isTitrationSchedule: false})

        }
        this.editTreatmentPlan("TreatmentSchedule", val, index)
    }
    changeView = (num) => {
        this.setState({view: this.state.view === num ? 0 : num});
    }


    getTitrationPlan = (val, index) => {
        this.props.getTitrationPlan(val, index)
    }


    addTreatmentPlan() {
        this.props.addTreatmentPlan()
    }


    showTreatment(index) {
        this.setState({showTreatment: index})
    }

    DeleteTreatment(index) {
        this.props.DeleteTreatment(index)
    }

    getSymptomsDesc = (Symptom_ID, lang) => {
        return this.props.getSymptomsDesc(Symptom_ID, lang)
    }

    editTreatmentPlan = (func, value, index) => {
        this.props.editTreatmentPlan(func, value, index)
    }
    getNewTitration = (initialDose, maxDosage, stepEach) => {
        this.props.getNewTitration(initialDose, maxDosage, stepEach)
    }


    render() {
        let {view, entry, titrationPlan} = this.state
        let {t} = this.props
        let {patientTreatments} = this.props

        let treatmentsTest = patientTreatments.map((item, index) =>
            <TreatmentPlanNotExpanded title={t('patient_boarding.Treatment')}
                                      Component={TreatmentPlanBlock}
                                      treatmentIndex={index}
                                      current={item}
                                      isExpanded ={item.isExpanded}
                                      t={(e) => this.props.t(e)}
                                      DeleteTreatment={(index) => this.DeleteTreatment(index)}
                                      getSymptomsDesc={(Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang)}
                                      rest={{
                                          treatmentIndex: index,
                                          onValueChange: (name, value) => this.onValueChange(name, value),
                                          getTitrationPlan: (val, index) => this.getTitrationPlan(val, index),
                                          setTitrationSchedule: (val, index) => this.setTitrationSchedule(val, index),
                                          getSymptomsDesc: (Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang),
                                          getTargetSymptoms: (index, item) => this.getTargetSymptoms(index, item),
                                          symptoms: this.props.symptoms,
                                          symptomsList: this.props.symptomsList,
                                          entry: this.props.entry,
                                          doctorName: this.props.entry.referralDoc,
                                          errors: this.props.errors,
                                          titrationPlans: this.props.titrationPlans,
                                          productsList: this.props.productsList,
                                          t: (e) => this.props.t(e),
                                          current: item,
                                          editTreatmentPlan: (func, value, index) => this.editTreatmentPlan(func, value, index),
                                      }}/>
        )

        return (

            <div className={'patientForm-box-container'}>
                <div className={'svg-label-treatment'}>
                    <SvGraphics className={"delete-icon"} svgname={'add-icon'} onClick={() => this.addPatientProduct("ADD","",0)}/>
                    <div className={'addTarget'} onClick={() => this.addTreatmentPlan()}>{t('patient_boarding.add_treatment_plan')}</div>
                </div>

                {treatmentsTest}

            </div>
        );
    }
}


const RequestTreatmentTargetsTab = compose(
    withTranslation(),
)(RequestTreatmentTargetsTabComposed);

export default RequestTreatmentTargetsTab;

